import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import { Toaster } from "@/components/ui/sonner";
import Layout from "@/components/Layout";
import Login from "@/pages/Login";
import Businesses from "@/pages/Businesses";
import BusinessDetail from "@/pages/BusinessDetail";
import ProjectDashboard from "@/pages/ProjectDashboard";

function FullScreenLoader() {
  return (
    <div className="min-h-screen flex items-center justify-center bg-background" data-testid="app-loading">
      <div className="w-8 h-8 rounded-sm bg-blue-800 dark:bg-blue-500 flex items-center justify-center animate-pulse">
        <span className="text-white font-display font-extrabold text-sm">W</span>
      </div>
    </div>
  );
}

function Protected({ children }) {
  const { user } = useAuth();
  const location = useLocation();
  if (user === undefined) return <FullScreenLoader />;
  if (!user) return <Navigate to="/login" replace state={{ from: location }} />;
  return children;
}

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route
              element={
                <Protected>
                  <Layout />
                </Protected>
              }
            >
              <Route path="/" element={<Businesses />} />
              <Route path="/businesses/:businessId" element={<BusinessDetail />} />
              <Route path="/businesses/:businessId/projects/:projectId" element={<ProjectDashboard />} />
            </Route>
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </BrowserRouter>
        <Toaster position="top-right" richColors />
      </AuthProvider>
    </div>
  );
}

export default App;
